import { useEffect, useMemo, useState } from "react";
import { useGetBB13ApplicationQuery } from "../redux/services/getBB13ApplicationStatus";
import { useAppSelector } from "../redux/hook";
import { StatusUpdateInterface } from "../models/interfaces/update-status.interface";
import { uniq } from "lodash";
import { BB13ApplicationStatusInterface } from "../models/interfaces/bb13ApplicationStatus.interface";
import config from "../config";

const useGetBB13ApplicationsByHDBRefs = (hdbRefList: string[], activeApplications: StatusUpdateInterface[]) => {
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);

  const activeApplicationHdbRefs = useMemo(() => activeApplications.map((e) => e.hdb_ref), [activeApplications]);
  const combinedHdbRefs = uniq([...hdbRefList, ...activeApplicationHdbRefs]);

  const { data: bb13Applications } = useGetBB13ApplicationQuery(
    { uinfin: loginUser?.uinfin ?? "", singpass_token: singpassToken ?? "", hdb_ref: combinedHdbRefs },
    { skip: combinedHdbRefs.length <= 0 || !loginUser?.uinfin }
  );

  const localDebugBb13Applications = useMemo(() => {
    return [];
    //   return [{
    //   address: "Blk 772, #16-145, Bedok Reservoir View, Singapore 319074",
    //   link: "https://services2u.nicehomes.com.sg/webapp/BB13EApplication/BB13SFlatTransferMain",
    //   status:"5",//change status here to debug locally
    //   hdb_ref: "73300148131"
    // }].map(item => item as BB13ApplicationStatusInterface)
  }, []);

  const filteredBb13Applications = useMemo(() => {
    const processingBb13Applications = !config.isLocalhost ? bb13Applications : localDebugBb13Applications;
    return (
      processingBb13Applications?.filter((bb13Application) => {
        if (!activeApplicationHdbRefs.includes(bb13Application.hdb_ref)) {
          return true;
        }
        const bb13Appstatus = parseInt(bb13Application.status, 10);
        return bb13Appstatus >= 1 && bb13Appstatus <= 6;
      }) ?? []
    );
  }, [bb13Applications, activeApplicationHdbRefs, localDebugBb13Applications]);

  return { applicationsData: filteredBb13Applications };
};

export default useGetBB13ApplicationsByHDBRefs;
